// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"addon_info_tooltip-module_wrapper_6216d","popover":"addon_info_tooltip-module_popover_fade7"};